import {
  PAYMENT_CANCEL_REQUESTS_REQUEST,
  PAYMENT_CANCEL_REQUESTS_RESPONSE,
} from '../actions/paymentCancelRequest.action';

export default function paymentCancelRequest(state = {paymentCancelRequests: []}, action) {
  switch (action.type) {
    case PAYMENT_CANCEL_REQUESTS_REQUEST: {
      let nextState = {...state};
      return nextState;
    }
    case PAYMENT_CANCEL_REQUESTS_RESPONSE: {
      let nextState = {...state};
      nextState.paymentCancelRequests = action.paymentCancelRequests;
      return nextState;
    }
  }
  return state;
}
